import React, { useState } from 'react';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
    });

    const [status, setStatus] = useState({
        submitting: false,
        submitted: false,
        error: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setStatus({ submitting: true, submitted: false, error: null });

        // Validation
        if (!formData.name || !formData.email || !formData.message) {
            setStatus({
                submitting: false,
                submitted: false,
                error: 'Please fill in all required fields (Name, Email, and Message).'
            });
            return;
        }

        try {
            const response = await fetch( 'https://cheery-tartufo-363c3d.netlify.app/.netlify/functions/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    service: formData.service,
                    message: formData.message
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to send message');
            }

            setStatus({
                submitting: false,
                submitted: true,
                error: null
            });

            // Reset form
            setFormData({
                name: '',
                email: '',
                phone: '',
                service: '',
                message: ''
            });

        } catch (error) {
            setStatus({
                submitting: false,
                submitted: false,
                error: error.message || 'Something went wrong. Please try again.'
            });
        }
    };

    return (
        <section className="contact" id="contact">
            <div className="container">
                <div className="contact-header">
                    <div className="section-header">
                        <span className="section-label">Get in Touch</span>
                        <h2 className="section-title">
                            Begin the Conversation
                            <br />
                            <strong>Let's build something serious.</strong>
                        </h2>
                    </div>
                </div>

                <div className="contact-form-container">
                    {!status.submitted ? (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    disabled={status.submitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Business Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    disabled={status.submitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    disabled={status.submitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="service">Service Interest</label>
                                <input
                                    type="text"
                                    id="service"
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    placeholder="Message"
                                    disabled={status.submitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Project Overview</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    disabled={status.submitting}
                                />
                            </div>

                            {status.error && (
                                <div style={{
                                    padding: '15px',
                                    marginBottom: '20px',
                                    background: 'rgba(231, 76, 60, 0.1)',
                                    border: '1px solid rgba(231, 76, 60, 0.3)',
                                    borderRadius: 'var(--border-radius)',
                                    color: '#e74c3c',
                                    fontSize: '0.95rem'
                                }}>
                                    {status.error}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="submit-button"
                                disabled={status.submitting}
                            >
                                {status.submitting ? 'Sending...' : 'Submit Project Inquiry'}
                            </button>
                        </form>
                    ) : (
                        <div className="success-message" style={{ display: 'block' }}>
                            ✓ Thank you. We'll review your inquiry and contact you within 24 hours.
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
